import type { FAMOnboarding } from '../../models/membership/famOnboarding';
import { requests } from '../httpClient';

export const FamOnboarding = {
    getFamOnboardingDetailsAsync: () => requests.get(`FamOnboarding`),
    getFamOnboardingCanPayStatusCodesAsync: () => requests.get(`FamOnboarding/CanPayStatusCodes`),
    getByIdAsync: (id: string) => requests.get(`FamOnboarding/${id}`),
    updateFamOnboardingDetailsAsync: (data: FAMOnboarding) => requests.put(`FamOnboarding`, data),
    submitFamOnboardingDetailsAsync: (famExamId: string) => requests.put(`FamOnboarding/Submit`, { FamExamId: famExamId }),
    basketAsync: (famExamId: string) => requests.post(`FamOnboarding/Basket`, { FamExamId: famExamId })
};
